import { NavBar } from '@/components/layout/Nav/NavBar';
import { SideNav } from '@/components/layout/Nav/SideNav';
import { useEffect } from 'react';
import { Footer } from '@/components/layout/Footer';
import { ModalLoading } from '@/components/element/modal/ModalLoading';

type Props = {
  children?: React.ReactNode;
};

export const WorkspaceLayout = (props: Props) => {
  useEffect(() => {
    document.body.classList.add('g-sidenav-show');
  }, []);

  return (
    <>
      <SideNav />
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <NavBar />

        {props.children}

        {/*<Footer />*/}

        <ModalLoading />
      </main>
    </>
  );
};
